var map = {
	"./bnb.png": "52ce",
	"./ether.png": "7c29",
	"./polygon.png": "36c5",
	"./solana.png": "21e3",
	"./trx.png": "1dd5",
	"./usdc.png": "350f",
	"./usdt.png": "6593"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ef5";